import Eye from 'lucide-react/dist/esm/icons/eye';
import EyeOff from 'lucide-react/dist/esm/icons/eye-off';
import { Ref, useState } from 'react';

import { Button } from '@/components/ui/Button';
import { FormTextInput, FormTextInputProps } from '@/components/ui/form/FormTextInput';

export type FormPasswordInputProps = FormTextInputProps & {
  showToggle?: boolean;
};

export const FormPasswordInput = ({
  inputActions,
  showToggle = true,
  disabled,
  readOnly,
  ref,
  ...inputProps
}: FormPasswordInputProps & { ref?: Ref<HTMLInputElement> }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ToggleIcon = isVisible ? EyeOff : Eye;

  return (
    <FormTextInput
      ref={ref}
      type={isVisible ? 'text' : 'password'}
      inputActions={
        showToggle || inputActions ? (
          <div className="flex gap-2">
            {inputActions}
            {showToggle ? (
              <Button
                type="button"
                size="icon"
                variant="icon"
                aria-label={isVisible ? 'Hide password' : 'Show password'}
                aria-pressed={isVisible}
                onClick={() => setIsVisible((prev) => !prev)}
                disabled={disabled || readOnly}
              >
                <ToggleIcon className="size-4" />
              </Button>
            ) : null}
          </div>
        ) : null
      }
      disabled={disabled}
      readOnly={readOnly}
      {...inputProps}
    />
  );
};
FormPasswordInput.displayName = 'FormPasswordInput';
